<template>
  <swiper class="stories-group-slider" :modules="swiperOptions.modules" :pagination="swiperOptions.pagination">
    <swiper-slide class="stories-group-slider__item">
      <div class="stories-group-slider__item-body">
        <img class="stories-group-slider__item-body_image" :src="mainStory.thumbnail" :alt="mainStory.title">
      </div>
    </swiper-slide>

    <div class="swiper-pagination stories-group-slider__pagination"></div>
  </swiper>
</template>

<script setup>
import {ref} from 'vue';
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Pagination} from 'swiper';
import 'swiper/css';

const props = defineProps({
  mainStory: {
    type: Object,
    default: () => {
    }
  }
});

const swiperOptions = ref({
  modules: [Pagination],
  pagination: {
    el: ".stories-group-slider__pagination",
    type: "bullets",
    clickable: false,
    renderBullet: function (index, className) {
      return (
          '<div class="' + className + '">' + "<span>" + "</span>" + "</div>"
      );
    },
  }
});


</script>

<style scoped>
.stories-group-slider__item-body_image {
  min-width: 300px;
}


.stories-group-slider {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 0.75rem;
}

@media only screen and (max-width: 767px) {
  .stories-group-slider {
    border-radius: 0;
  }
}

.stories-group-slider__item {
  padding: 0.5rem;
  width: 100%;
  height: 100%;
}

.stories-group-slider__item-body {
  font-size: 2rem;
  line-height: 1.2;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}

@media only screen and (max-width: 767px) {
  .stories-group-slider__item-body {
    font-size: 25px;
  }
}

.stories-group-slider__pagination {
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 2rem;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 100;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.8s ease;
}

@media only screen and (max-width: 767px) {
  .stories-group-slider__pagination {
    top: 4rem;
  }
}

.stories-group-slider__pagination :deep(.swiper-pagination-bullet) {
  position: relative;
  width: 100%;
  flex-shrink: 10;
  border-radius: 999px;
  height: 4px;
  background-color: rgba(31, 41, 56, 0.16);
  overflow: hidden;
  box-shadow: 0 0 1px #000 59;
  margin-right: 0.9rem;
}

.stories-group-slider__pagination :deep(.swiper-pagination-bullet):first-child {
  margin-left: 2rem;
}

.stories-group-slider__pagination :deep(.swiper-pagination-bullet):last-child {
  margin-right: 2rem;
}

.stories-group-slider__pagination :deep(.swiper-pagination-bullet) span {
  position: absolute;
  background-color: #1f2938;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 999px;
  transform: translateX(-100%);
  transition: transform 0.3s ease;
}
</style>